<template>

  <v-card>
    <v-card-title  >
    <v-toolbar-title color="primary" >

      <p style="color:#4A76A8">
       {{init.dialogLabel}}
      </p>

    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="init.dialogOpen = false;init.vModel.value = false">mdi-close</v-icon>
</v-card-title>

<v-card-text>

  <div v-if="init.vModel.name == 'status'">
  <p style="color:#757575;font-size:1.3em">
   Параметры статуса
  </p>

 <div style="margin:10px">


   <v-checkbox label="Присутсвие статуса"></v-checkbox>
   <v-checkbox label="Отсутствие статуса"></v-checkbox>
   <v-text-field clearable  label="Ключевые слова через запятую"></v-text-field>
   <v-text-field clearable  label="Минус ключевые слова через запятую"></v-text-field>
<v-text-field clearable  label="Регулярное выражение"></v-text-field>
<v-text-field clearable  label="Минус регулярное выражение"></v-text-field>

 </div>
</div>




<div v-if="init.vModel.name == 'descSemantic'">
  <div style="margin:10px">

    <template>
      <v-combobox
       hint="Плюс слова/фразы через enter"
        v-model="init.descSemanticParams.wordsPlus.items"
        label="Плюс слова"
        chips
        clearable
        solo
        multiple
      >

      <template
       slot="selection"
       slot-scope="data"
     >
       <v-chip

         :selected="data.selected"
         close
         class="chip--select-multi"
         @input="remove(data.item)"
       >

         {{ data.item }}
       </v-chip>
     </template>

      </v-combobox>
    </template>



    <template>
      <v-combobox
       hint="Минус слова/фразы через enter"
        v-model="init.descSemanticParams.wordsMinus.items"
        label="Минус слова"
        chips
        clearable
        solo
        multiple
      >

      <template
       slot="selection"
       slot-scope="data"
     >
       <v-chip

         :selected="data.selected"
         close
         class="chip--select-multi"
         @input="removeMinus(data.item)"
       >

         {{ data.item }}
       </v-chip>
     </template>

      </v-combobox>
    </template>
 



  <v-checkbox  v-model="init.descSemanticParams.hasPhone"  label="Наличие мобильного телефона">   </v-checkbox>
  <v-checkbox  v-model="init.descSemanticParams.hasSite" label="Имеются ссылки">   </v-checkbox>
  <v-checkbox  v-model="init.descSemanticParams.hasEmail" label="Наличие Почты">   </v-checkbox>




</div>

<div style="margin:10px">



</div>
</div>













<div v-if="init.vModel.name == 'postSemantic'">



<div style="margin:10px">

   <v-subheader>Сколько брать постов на анализ ?</v-subheader>


   <v-slider
  v-model="init.postSemanticParams.postCount"
  min="1"
  always-dirty
  persistent-hint
  thumb-label="always"
></v-slider>


 <v-text-field
  v-model="init.postSemanticParams.offset"
  clearable
  label="Начальная позиция с которой брать посты"
  hint="целое число"
   >

 </v-text-field>



 <v-expansion-panel
    expand
  >
    <v-expansion-panel-content >




<div slot="header" style="color:#757575;font-size:1.3em">
 Колличественные параметры (средние значение)
</div>


<div style="margin:10px">
<v-text-field mask="##"   v-model="init.postSemanticParams.authorsMin" hint="целое число  от единицы" label="Разных авторов не менее чем" clearable><v-icon  :color="fullfit(init.postSemanticParams.authorsMin)" slot="prepend">mdi-account-multiple</v-icon></v-text-field>
<v-text-field mask="##"    v-model="init.postSemanticParams.authorsMax" hint="целое число  от единицы" label="Разных авторов не более чем" clearable><v-icon :color="fullfit(init.postSemanticParams.authorsMax)"  slot="prepend">mdi-account-multiple</v-icon></v-text-field>



<v-text-field mask="###########"    v-model="init.postSemanticParams.viewsMin" hint="целое число  от единицы" label="Просмотров в среднем не менее чем" clearable><v-icon :color="fullfit(init.postSemanticParams.viewsMin)"  slot="prepend">mdi-eye</v-icon></v-text-field>
<v-text-field mask="###########"    v-model="init.postSemanticParams.viewsMax" hint="целое число  от единицы" label="Просмотров в среднем не более чем" clearable><v-icon :color="fullfit(init.postSemanticParams.viewsMax)" slot="prepend">mdi-eye</v-icon></v-text-field>


<v-text-field mask="########"   v-model="init.postSemanticParams.likesMin"  hint="целое число  от единицы" label="Лайков в среднем не менее чем" clearable><v-icon :color="fullfit(init.postSemanticParams.likesMin)" slot="prepend">mdi-thumb-up</v-icon></v-text-field>
<v-text-field mask="########"   v-model="init.postSemanticParams.likesMax" hint="целое число  от единицы" label="Лайков в среднем  не более чем" clearable><v-icon :color="fullfit(init.postSemanticParams.likesMax)" slot="prepend">mdi-thumb-up</v-icon></v-text-field>


<v-text-field mask="#########"   v-model="init.postSemanticParams.commentsMin"  hint="целое число  от единицы" label="Комментариев в среднем  не менее чем" clearable>><v-icon :color="fullfit(init.postSemanticParams.commentsMin)" slot="prepend">mdi-comment</v-icon></v-text-field>
<v-text-field mask="#########"   v-model="init.postSemanticParams.commentsMax" hint="целое число  от единицы" label="Комментариев в среднем  не более чем" clearable>><v-icon :color="fullfit(init.postSemanticParams.commentsMax)" slot="prepend">mdi-comment</v-icon></v-text-field>


<v-text-field mask="#########"   v-model="init.postSemanticParams.repostsMin"  hint="целое число  от единицы" label="Репостов в среднем  не менее чем" clearable>><v-icon :color="fullfit(init.postSemanticParams.repostsMin)" slot="prepend">mdi-share</v-icon></v-text-field>
<v-text-field mask="#########"   v-model="init.postSemanticParams.repostsMax" hint="целое число  от единицы" label="Репостов в среднем  не более чем" clearable>><v-icon :color="fullfit(init.postSemanticParams.repostsMax)" slot="prepend">mdi-share</v-icon></v-text-field>
</div>
</v-expansion-panel-content >




<v-expansion-panel-content >
<div slot="header" style="color:#757575;font-size:1.3em">
 Процентные сообнощения
</div>

<div style="margin:10px">

<v-text-field v-model="init.postSemanticParams.likeToViewMin" clearable hint="дробное или целое  число например: 1.20 или 2 или 0.08" label="лайков к просмотрам минимум %"> </v-text-field>
<v-text-field v-model="init.postSemanticParams.likeToViewMax" clearable  hint="дробное или целое  число например: 1.2 или 2  или 0.08" label="лайков к просмотрам максимум %"> </v-text-field>


</div>
</v-expansion-panel-content >










<v-expansion-panel-content >
<div slot="header" style="color:#757575;font-size:1.3em">
 Семантика
</div>

<div style="margin:10px">
<v-text-field v-model="init.postSemanticParams.wordsPlus" hint="слова или фразы через запятую" label="Плюс слова" clearable></v-text-field>
<v-text-field v-model="init.postSemanticParams.wordsMinus" hint="слова или фразы через запятую" label="Минус слова" clearable></v-text-field>

<v-text-field v-model="init.postSemanticParams.regPlus" hint="регулярка будет проходить по общему тексту всех постов" label="Плюс регулярное выражение" clearable></v-text-field>
<v-text-field v-model="init.postSemanticParams.regMinus" hint="регулярка будет проходить  по общему тексту всех постов (в случаи совпадения исключит сообщество)" label="Минус регулярное выражение" clearable></v-text-field>
</div>
</v-expansion-panel-content >
</v-expansion-panel>


</div>
</div>










</v-card-text>

 <v-card-actions>
   <v-btn flat @click="init.dialogOpen = false;init.vModel.value = false" block color="primary">  Отмена  </v-btn>
   <v-btn @click="init.dialogOpen = false;init.vModel.value = true" block color="primary">  Сохранить  </v-btn>
 </v-card-actions>
  </v-card>

</template>

<script>

import axios from 'axios'
export default {
  props:['init' ],
  data () {
    return {

    }
  },
methods:{
  fullfit(data){
    if(data){
      return 'green'
    } else return ''

  },
  remove(item){
    this.init.descSemanticParams.wordsPlus.items.splice(this.init.descSemanticParams.wordsPlus.items.indexOf(item), 1)
    this.init.descSemanticParams.wordsPlus.items = [...this.init.descSemanticParams.wordsPlus.items]
  },
  removeMinus(item){
    this.init.descSemanticParams.wordsMinus.items.splice(this.init.descSemanticParams.wordsMinus.items.indexOf(item), 1)
    this.init.descSemanticParams.wordsMinus.items = [...this.init.descSemanticParams.wordsMinus.items]
  }
},
computed:{



},



}
</script>
<style>
.green {
  color: green;
}

</style>
